<template>
  <!-- 任务提醒 -->
  <el-container class="taskReminder">
    <div class="task-reminder-search">
      <!-- <label>服务链名称</label> -->
      <el-select v-model="caseMgrTaskV2VO.wholeCourseId" filterable placeholder="请选择服务链名称" size="mini" clearable>
        <el-option v-for="item in schemeNameList" :key="item.wholeCourseId" :label="item.name"
          :value="item.wholeCourseId">
        </el-option>
      </el-select>
      <div class="file-name">
        <el-input placeholder="请输入任务名称" prefix-icon="el-icon-search" v-model="caseMgrTaskV2VO.keyWord" size="mini"
          clearable>
        </el-input>
      </div>
      <el-button type="primary" size="mini" @click="searchClick(7)">搜索</el-button>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="addFeedback"
        :disabled="logOff || (!schemeNameList || !schemeNameList.length)">添加反馈</el-button>
    </div>
    <el-tabs style="margin-left: 20px; margin-right: 20px;" v-model="activeName" @tab-click="tabHandleClick">
      <el-tab-pane label="当前反馈" name="current"></el-tab-pane>
      <el-tab-pane label="历史反馈" name="history"></el-tab-pane>
    </el-tabs>
    <el-main v-if="activeName == 'current'">
      <el-scrollbar style="height: 100%;font-size: 12px">
        <!-- 未标记任务 -->
        <taskReminderItem v-if="caseMgrTaskV2VO.caseMgrTaskFlag" :list="caseMgrTaskV2VO.caseMgrTaskVOList"
          :patientId="patientId" @handleFeedbackVisible="handleFeedbackVisible">
        </taskReminderItem>
        <!-- 已标记 -->
        <taskReminderItem v-if="caseMgrTaskV2VO.finishCaseMgrTaskVOList.length"
          :list="caseMgrTaskV2VO.finishCaseMgrTaskVOList" :patientId="patientId" :isFinish="true"
          @handleFeedbackVisible="handleFeedbackVisible">
        </taskReminderItem>
        <!-- 有未标记并且也有已标记 没有未标记但已标记有数据并且被加载过 -->
        <div class="al-task"
          v-if="(caseMgrTaskV2VO.caseMgrTaskFlag && caseMgrTaskV2VO.finishCaseMgrTaskFlag) || (caseMgrTaskV2VO.finishCaseMgrTaskFlag && caseMgrTaskV2VO.page !== 0)"
          @click="loadFinishPatientFilesItem(7, ['caseMgrTaskV2VO', 'isCaseMgrTaskLoad'])">
          <span>加载已完成的任务<i class="el-icon-arrow-down"></i></span>
        </div>
        <!-- 所有任务已加载提示 -->
        <div class="fin-task" v-if="!caseMgrTaskV2VO.finishCaseMgrTaskFlag && caseMgrTaskV2VO.page !== 0">
          <span>已加载完全部任务</span>
        </div>
        <div class="empty"
          v-if="!caseMgrTaskV2VO.caseMgrTaskFlag && !caseMgrTaskV2VO.finishCaseMgrTaskFlag && caseMgrTaskV2VO.page === 0">
          暂无待提醒内容
        </div>
        <div class="empty"
          v-if="!caseMgrTaskV2VO.caseMgrTaskFlag && caseMgrTaskV2VO.finishCaseMgrTaskFlag && caseMgrTaskV2VO.page === 0">
          所有任务均已标记，辛苦啦
          <!-- 判断是否有已完成的数据，有已完成的数据则展示加载已完成任务 -->
          <div class="al-task" @click="loadFinishPatientFilesItem(7, ['caseMgrTaskV2VO', 'isCaseMgrTaskLoad'])">
            <span>加载已完成的任务<i class="el-icon-arrow-down"></i></span>
          </div>
        </div>
      </el-scrollbar>
    </el-main>
    <el-main v-if="activeName == 'history'">
      <el-scrollbar style="height: 100%;font-size: 12px">
        <taskReminderItem v-if="haveHistory" :list="historyList" :patientId="patientId"
          @handleFeedbackVisible="handleFeedbackVisible">
        </taskReminderItem>
        <div class="fin-task" v-else>
          <span>暂无内容</span>
        </div>
      </el-scrollbar>
    </el-main>
    <!-- 添加反馈 -->
    <add-feedback-dialog :addFeedbackVisible="addFeedbackVisible" :patientFeedbackTask="patientFeedbackTask"
      :title="addFeedbackTitle" :status="addFeedbackStatus" @addFeedbackClose="addFeedbackClose">
    </add-feedback-dialog>
  </el-container>
</template>

<script>
import {
  getHistoryCaseMgrTaskV2VOByPatientId,
} from "@/views/newPatientmanage/api/treatmentPlan.js";
import AddFeedbackDialog from "@/views/newPatientmanage/components/TaskList/addFeedbackDialog.vue";
import taskReminderItem from "./taskReminderItem.vue";

export default {
  name: "taskReminder",
  props: {
    caseMgrTaskV2VO: {
      type: Object
    },
    schemeNameList: {
      type: Array
    },
    patientId: {
      type: String
    },
    logOff: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AddFeedbackDialog,
    taskReminderItem,
  },
  data() {
    return {
      activeName: 'current',
      historyList: [],
      haveHistory: false,
      // 添加反馈弹框
      addFeedbackVisible: false,
      addFeedbackTitle: '添加反馈',
      addFeedbackStatus: 'add',
      patientFeedbackTask: {}
    };
  },
  mounted() { },
  filters: {
    getTypeName(type) {
      if (type == 1 || type == 8) {
        return '提醒任务'
      }
      if (type == 2) {
        return '问诊说明'
      }
      if (type == 3) {
        return '随访说明'
      }
      if (type == 4) {
        return '评估说明'
      }
      if (type == 5) {
        return '复诊计划'
      }
      if (type == 6) {
        return '重点指标'
      }
      if (type == 7) {
        return '及时反馈'
      }
      if (type == 9) {
        return '模版反馈'
      }
    },
  },
  methods: {
    tabHandleClick() {
      if (this.activeName === 'history') {
        this._getHistoryCaseMgrTaskV2VOByPatientId()
      }
    },
    _getHistoryCaseMgrTaskV2VOByPatientId() {
      getHistoryCaseMgrTaskV2VOByPatientId({
        patientId: this.patientId,
        wholeCourseId: this.caseMgrTaskV2VO.wholeCourseId,
        name: this.caseMgrTaskV2VO.keyWord,
        current: 1,
        size: 100,
      }).then(res => {
        if (res.code == 0) {
          this.historyList = res.data.records
          this.haveHistory = (this.historyList && this.historyList.length > 0)
        }
      })
    },
    loadFinishPatientFilesItem() {
      this.$emit("getPatientRightData", 7, [
        "caseMgrTaskV2VO",
        "isCaseMgrTaskLoad"
      ]);
    },
    searchClick() {
      if (this.activeName == 'history') {
        this._getHistoryCaseMgrTaskV2VOByPatientId()
        return
      }
      this.$emit("getPatientRightData", 7);
    },
    handleFeedbackVisible(map) {
      this.addFeedbackTitle = map.addFeedbackTitle
      this.addFeedbackStatus = map.addFeedbackStatus
      this.addFeedbackVisible = map.addFeedbackVisible
      this.patientFeedbackTask = map.patientFeedbackTask
    },
    addFeedback() {
      this.addFeedbackTitle = '添加反馈'
      this.addFeedbackStatus = 'add'
      this.addFeedbackVisible = true
      this.patientFeedbackTask = {
        patientId: this.patientId,
        wholeCourseId: this.caseMgrTaskV2VO.wholeCourseId,
        diseaseId: this.caseMgrTaskV2VO.diseaseId,
        refId: '',
      }
    },
    addFeedbackClose(flag, update) {
      this.addFeedbackVisible = flag;
      if (update) {
        this.$emit("getPatientRightData", 7);
        if (this.activeName == 'history') {
          this._getHistoryCaseMgrTaskV2VOByPatientId()
        }
      }
    }
  }
};
</script>

<style lang="less">
@import "./taskReminder.less";
</style>

<style scoped lang="less">
/deep/ .el-tabs__header {
  margin-bottom: 0px !important;
}
</style>
